const mutation = {

  SET_LR_LOADING(state, status) {
    state.isLrLoading = status;
  },

  SET_LR(state, data) {
    state.list = data;
  },
  SET_CERTITFICATION(state, data) {
    state.certifications = data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  setUploading(state, data) {
    state.isUploading = data;
  },
  SET_CONFIGURATION_ROLES(state, { permissionList, rolePermissions }) {
    state.permissionList = permissionList;
    state.rolePermissions = rolePermissions;
  },


};

export default mutation;
